import Tasks from './tasks.component'

const DrFiles = (props) => {
  return <Tasks {...props}/>
}

export default DrFiles